const baseUrl = process.env.REACT_APP_CUCA_MI_CUENTA_BFF_URL;
const market = process.env.REACT_APP_MARKET;

export const ripleyCreditCardPaymentPE =
  process.env.REACT_APP_PE_URL_RIPLEY_CARD_PAYMENT || '';
export const ripleyTrackingWebsitePE =
  process.env.REACT_APP_PE_URL_RIPLEY_TRACKING_SIMPLE || '';
export const contactUrl = process.env.REACT_APP_CONTACT_URL || '';
export const advanceRequestUrl =
  process.env.REACT_APP_URL_ADVANCE_REQUEST || '';

export const termsRPGOBank = process.env.REACT_APP_TERMS_RPGO_BANK || '';
export const legalRPGOBank = process.env.REACT_APP_LEGAL_RPGO_BANK || '';
export const termsAuthorization =
  process.env.REACT_APP_TERMS_AUTHORIZATION || '';
export const privacyPolicies = process.env.REACT_APP_PRIVACY_POLICIES || '';

export const simpleUrl = process.env.REACT_APP_URL_SIMPLE || '';

export const contactForm = process.env.REACT_APP_CONTACT_FORM || '';

export const benefitProgramRpGoUrl =
  process.env.REACT_APP_PE_URL_RPGO_BENEFIT_PROGRAM || '';
export const contactFormPe = process.env.REACT_APP_PE_URL_CONTACT_FORM || '';
export const dvuelveFormPe = process.env.REACT_APP_PE_URL_FORM_DVUELVE || '';
export const getProfileUser = `${baseUrl}/markets/${market}/customers`;
export const logoutUser = `${baseUrl}/markets/${market}/auth/logout`;
export const regionsMarket = `${baseUrl}/markets/${market}/regions`;
export const changePassword = `${baseUrl}/markets/${market}/auth/password`;
export const addressBase = `${baseUrl}/markets/${market}/customers`;
export const getProfileCategory = `${baseUrl}/markets/${market}/loyalty/customer`;
export const getProducts = `${baseUrl}/markets/${market}/orders/customer/v2`;
export const getTracking = `${baseUrl}/markets/${market}/dispatches`;
export const getImage = `${baseUrl}/markets/${market}/images/product`;
export const getGiftcardBalance = `${baseUrl}/markets/${market}/gift-card`;
export const getBankBenefits = `${baseUrl}/markets/${market}/bank/benefits`;
export const getCustomerExchanges = `${baseUrl}/markets/${market}/bank/customer`;
export const getBankCategories = `${baseUrl}/markets/${market}/bank/exchanges/categories`;
export const getCustomerPoints = `${baseUrl}/markets/${market}/bank/customer`;
export const getProductsByCategory = `${baseUrl}/markets/${market}/bank/exchanges/category`;
export const getTickets = `${baseUrl}/markets/${market}/tickets/customer`;
export const createTicketsNoProduct = `${baseUrl}/markets/${market}/tickets/create`;
export const validateProductByMotive = `${baseUrl}/markets/${market}/tickets/motive`;
export const selfServiceByMotive = `${baseUrl}/markets/${market}/self-service`;
export const getBannerBank = `${baseUrl}/markets/${market}/banner/bank`;
